import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
} from "@ant-design/icons";

const PaymentResultPage: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const status = searchParams.get("status"); // success | failed
    const reference = searchParams.get("reference");
    const message =
        searchParams.get("message") ||
        "Something went wrong while processing your payment.";

    const isSuccess = status === "success";

    return (
        <div className="min-h-screen bg-gray-900 text-white px-6 py-12 flex items-center justify-center">
            <div className="max-w-2xl w-full bg-gray-800 rounded-2xl shadow-lg p-10 text-center space-y-8">
                {/* Icon */}
                <div className="flex justify-center">
                    {isSuccess ? (
                        <CheckCircleOutlined className="text-green-400 text-6xl" />
                    ) : (
                        <CloseCircleOutlined className="text-red-400 text-6xl" />
                    )}
                </div>

                {/* Heading */}
                <h1
                    className={`text-3xl md:text-4xl font-bold ${isSuccess ? "text-blue-300" : "text-red-300"
                        }`}
                >
                    {isSuccess ? "Payment Successful 🎉" : "Payment Failed ❌"}
                </h1>

                {/* Message */}
                <p className="text-gray-300 leading-relaxed">
                    {isSuccess ? (
                        <>
                            Thank you for making your payment on{" "}
                            <strong>Keyway App</strong>. Your transaction was completed
                            successfully.
                            <br />
                            Please restart Your app for the effect to be active.
                        </>
                    ) : (
                        <>
                            Unfortunately, your payment could not be completed.
                            <br />
                            <span className="text-gray-400 text-sm">{message}</span>
                        </>
                    )}
                </p>

                {/* Reference */}
                {reference && (
                    <p className="text-sm text-gray-400">
                        <strong>Transaction Reference:</strong> {reference}
                    </p>
                )}

                {/* Actions */}
                {/* <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          {isSuccess ? (
            <button
              onClick={() => navigate("/dashboard")}
              className="px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 transition font-semibold"
            >
              Go to Dashboard
            </button>
          ) : (
            <button
              onClick={() => navigate("/checkout")}
              className="px-6 py-3 rounded-lg bg-red-600 hover:bg-red-700 transition font-semibold"
            >
              Try Payment Again
            </button>
          )}

          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 rounded-lg border border-gray-600 hover:bg-gray-700 transition font-semibold"
          >
            Back to Home
          </button>
        </div> */}

                {/* Support */}
                <div className="pt-6 border-t border-gray-700 text-sm text-gray-400">
                    <p>
                        Need help? Contact{" "}
                        <a
                            href="mailto:contact@businessyield.com"
                            className="text-blue-400 underline"
                        >
                            contact@businessyield.com
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PaymentResultPage;
